export default {
  "app.setting.pagestyle": "Cài đặt kiểu trang",
  "app.setting.pagestyle.dark": "Kiểu tối",
  "app.setting.pagestyle.light": "Kiểu sáng",
  "app.setting.content-width": "Chiều rộng nội dung",
  "app.setting.content-width.fixed": "Cố định",
  "app.setting.content-width.fluid": "Linh hoạt",
  "app.setting.themecolor": "Màu chủ đề",
  "app.setting.themecolor.dust": "Đỏ bụi",
  "app.setting.themecolor.volcano": "Núi lửa",
  "app.setting.themecolor.sunset": "Cam hoàng hôn",
  "app.setting.themecolor.cyan": "Xanh lơ",
  "app.setting.themecolor.green": "Xanh lá cực",
  "app.setting.themecolor.daybreak": "Xanh bình minh (mặc định)",
  "app.setting.themecolor.geekblue": "Xanh geek",
  "app.setting.themecolor.purple": "Tím vàng",
  "app.setting.navigationmode": "Chế độ điều hướng",
  "app.setting.sidemenu": "Bố cục menu bên",
  "app.setting.topmenu": "Bố cục menu trên",
  "app.setting.fixedheader": "Header cố định",
  "app.setting.fixedsidebar": "Sidebar cố định",
  "app.setting.fixedsidebar.hint": "Hoạt động với bố cục menu bên",
  "app.setting.hideheader": "Ẩn header khi cuộn",
  "app.setting.hideheader.hint": "Hoạt động khi ẩn header được bật",
  "app.setting.othersettings": "Cài đặt khác",
  "app.setting.weakmode": "Chế độ thân thiện với người mù màu",
  "app.setting.copy": "Sao chép cài đặt",
  "app.setting.copyinfo":
    "sao chép thành công, vui lòng thay thế defaultSettings trong src/models/setting.js",
  "app.setting.production.hint":
    "Bảng cài đặt chỉ hiển thị trong môi trường phát triển, vui lòng sửa đổi thủ công",
};
